export default __webpack_public_path__ + "static/media/content_tab01_04.ef1d8a95.jpg";